'use client'

import Link from 'next/link'

export default function WhoWeWorkWith() {
	return (
		<section className="py-20 section-bg-dark relative overflow-hidden">
			{/* Background Pattern */}
			<div className="absolute inset-0 opacity-10">
				<div className="absolute inset-0 bg-gradient-to-br from-eskerium-blue/20 to-eskerium-gold/20"></div>
			</div>
			
			<div className="section-container relative z-10">
				<div className="text-center mb-16">
					<div className="brand-chip mb-4">Who we work with</div>
					<h3 className="heading-lg text-hierarchy-1 mb-6">
						Power Your Products<br/>with Ingredients that Consumers Love
					</h3>
				</div>
				
				<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
					<Link href="/use-cases#brands" className="group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105">
						<div className="relative h-80">
							<img 
								src="/images/brands.jpg" 
								alt="Consumer Product Brands" 
								className="w-full h-full object-cover"
							/>
							<div className="absolute inset-0 bg-gradient-to-t from-eskerium-dark via-eskerium-dark/50 to-transparent"></div>
							
							{/* Content Overlay */}
							<div className="absolute bottom-0 left-0 right-0 p-8">
								<h4 className="text-2xl font-bold text-white mb-3 group-hover:text-eskerium-gold transition-colors">
									Consumer Product Brands
								</h4>
								<p className="text-white/90 leading-relaxed">
									Enhance your product portfolio with premium Live Resin ingredients.
								</p>
							</div>
							
							{/* Hover Effect */}
							<div className="absolute inset-0 bg-eskerium-gold/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
						</div>
					</Link>
					
					<Link href="/use-cases#copackers" className="group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105">
						<div className="relative h-80">
							<img 
								src="/images/copackers.jpg" 
								alt="Co-Packers and Manufacturers" 
								className="w-full h-full object-cover"
							/>
							<div className="absolute inset-0 bg-gradient-to-t from-eskerium-dark via-eskerium-dark/50 to-transparent"></div>
							
							{/* Content Overlay */}
							<div className="absolute bottom-0 left-0 right-0 p-8">
								<h4 className="text-2xl font-bold text-white mb-3 group-hover:text-eskerium-gold transition-colors">
									Co-Packers and Manufacturers
								</h4>
								<p className="text-white/90 leading-relaxed">
									Gain an edge with top-tier extracts that meet evolving market demands.
								</p>
							</div>
							
							{/* Hover Effect */}
							<div className="absolute inset-0 bg-eskerium-gold/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
						</div>
					</Link>
				</div>
			</div>
		</section>
	)
}

